var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"customer container"},[_vm._m(0),_c('div',{staticClass:"customer-list"},_vm._l((_vm.listData),function(item,index){return _c('customer-logo',{key:index,staticClass:"logo",attrs:{"imgdata":item}})}),1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('p',{staticClass:"title"},[_c('span',{staticClass:"title-text"},[_vm._v("服务客户"),_c('span',{staticClass:"title-line"})])])
}]

export { render, staticRenderFns }